import React from "react";

import Footer from "../components/Shared/Footer";

const AbdominalObesity = () => {
  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Abdominal obesity</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Resources</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 p-4 ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/AbdominalObesity/abd-one.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">Defining Obesity</h1>
                    </div>
                    <div className="mb-1">
                      <div className="font-sm mb-1 fw-semibold">
                        What is Obesity?
                      </div>
                      <p className="font-xsm justify_content">
                        Obesity is defined as abnormal or excessive fat
                        accumulation in our body, which is viewed as a
                        significant risk to health. A body mass index (BMI) over
                        25 is considered overweight, and over 30 is obese.
                      </p>
                    </div>
                    <div className="mb-1">
                      <div className="font-sm mb-1 fw-semibold">
                        Is it common in India?
                      </div>
                      <p className="font-xsm justify_content">
                        As per National Family Health Survey-5 (NFHS-5), <strong>one in
                        every four Indian women </strong>is now having obesity. It has been
                        reported that being overweight and obese is a
                        significant problem among all socio-economic classes in
                        India, especially seen in urban regions and in people
                        with sedentary lifestyles and unhealthy dietary habits.
                        <br></br>
                        <span className="font-xsm color-blue-abdominal mt-1 fw-semibold">
                          National Family Health Survey-5 (NFHS-5) states, one
                          in every four Indians is now having obesity.
                        </span>
                      </p>
                    </div>
                    <div className="mb-1">
                      <div className="font-sm mb-1 fw-semibold">
                        What does it indicate?
                      </div>
                      <p className="font-xsm justify_content">
                        Obesity indicates that there are higher fat deposits
                        across the body fat stores and is associated with
                        multiple adverse health conditions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                        Defining Abdominal Obesity
                      </h1>
                    </div>
                    <div className="mb-1">
                      <div className="font-sm mb-1 fw-semibold">
                        What is Abdominal Obesity?
                      </div>
                      <p className="font-xsm justify_content">
                        Abdominal obesity, also known as central obesity, is a
                        condition where there is an excessive amount of fat
                        around the belly. It is considered a more serious form
                        of fat distribution especially when a person is also
                        obese, as it can lead to more complex disorders and even
                        heart disease. It is measured by waist circumference.
                        Waist circumference more than 80 cm in women and more
                        than 94 cm in men is suggestive of abdominal obesity. A
                        person may not be obese (BMI {">"}30) but can still have
                        abdominal obesity.<br></br>
                        <span className="font-xsm color-blue-abdominal mt-1 fw-semibold">
                          Don’t love your love handles!!
                        </span>
                      </p>
                    </div>
                    <div className="mb-1">
                      <div className="font-sm mb-1 fw-semibold">
                        Is it common in India?
                      </div>
                      <p className="font-xsm justify_content">
                        The prevalence of abdominal obesity in the country was
                        found to be 40% in women. The findings show that 
                       <br></br>
                        <span className="font-xsm color-blue-abdominal mt-1 fw-semibold">
                          5–6 out of 10 women between the ages of 30–49 have
                          abdominal obesity.
                        </span>
                      </p>
                    </div>
                    <div className="mb-1">
                      <div className="font-sm mb-1 fw-semibold">
                        What does it indicate?
                      </div>
                      <p className="font-xsm justify_content">
                        Abdominal obesity indicates a higher risk for developing
                        insulin resistance and, consequently, is associated with
                        an increased risk for diabetes and heart disease.
                        <br></br>
                        <span className="font-xsm color-blue-abdominal mt-1 fw-semibold">
                          Abdominal obesity leads to insulin resistance and risk
                          of future diabetes.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/AbdominalObesity/indian_map.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="fresh-vegetable-section client-section  section-lg-space">
        <div className="container-fluid-lg">
          <div className="text-center">
            <div className="review-title">
              <h1 className="font-lg mb-2 text-center">
                Health risks
              </h1>
            </div>
            <div className="font-sm mb-3 fw-semibold text-center">
              Health risks associated with obesity and Abdominal obesity
            </div>
          </div>

          <div>
            <div className="row mb-3">
              <div className="col-xl-3 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue   align-items-center  d-flex justify-content-center p-4">
                  <div>
                    <h3 className="font-smd text-white mb-1 ">
                      Type 2 diabetes
                    </h3>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue   align-items-center  d-flex justify-content-center p-4">
                  <div>
                    <h3 className="font-smd text-white mb-1 ">Heart disease</h3>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue d-flex    align-items-center  justify-content-center p-4">
                  <div>
                    <h3 className="font-smd text-white mb-1 ">
                      High blood pressure
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue d-flex    align-items-center  justify-content-center p-4">
                  <div>
                    <h3 className="font-smd text-white mb-1 ">
                      High blood cholesterol
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <div className="row width_80 d-flex justify-content-center ">
                <div className="col-xl-4 mb-2">
                  <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue   align-items-center  d-flex justify-content-center p-4">
                    <div>
                      <h3 className="font-smd text-white mb-1 ">
                        Bone and joint problems
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 mb-2">
                  <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue   align-items-center  d-flex justify-content-center p-4">
                    <div>
                      <h3 className="font-smd text-white mb-1 ">
                        Disturbed sleep
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 mb-2">
                  <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue d-flex    align-items-center  justify-content-center p-4">
                    <div className="d-flex align-items-center justify-content-center">
                      <h3 className="font-smd text-white text-center mb-1 ">
                        Gallstones and liver problems
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg  d-flex justify-content-center align-items-center">
          <div className="">
            <div className="row  d-flex justify-content-center ">
            
              <div className="col-xl-5 mb-2 ">
                <div className="custom-image-container fresh-image d-flex  align-items-center">
                  <img
                    src="../assets/images/Riskofheartdieases/health_risk.jpg"
                    alt=""
                    className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                  />
                </div>
              </div>
              <div className="col-xl-7 d-flex  align-items-center justify-content-center ">
                <div>
                  <div className="mb-3">
                  <div className="review-title mb-3">
                    <h1 className="font-lg mb-3 text-center">Health risks</h1>
                  </div>
                  <div className="text-center ">
                    <p className="">
                      Health risks associated with obesity and Abdominal obesity
                    </p>
                  </div>

                  </div>
                  

                  <div className="tickforrisk text-muted">
                    <div className="d-flex gap-2 font-sm align-items-center custom-ticks ">
                      <div className="font-lg fas fa-check "></div>Type 2 diabetes
                    </div>
                    <div className="d-flex gap-2 font-sm align-items-center custom-ticks ">
                      <div className="font-lg fas fa-check "></div>
                      Heart disease
                    </div>

                    <div className="d-flex gap-2 font-sm align-items-center   custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      High blood pressure
                    </div>
                    <div className="d-flex gap-2 font-sm align-items-center custom-ticks ">
                      <div className="font-lg fas fa-check "></div>
                      High blood cholesterol
                    </div>
                    <div className="d-flex gap-2 font-sm align-items-center  custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      Bone and joint problems
                    </div>

                    <div className="d-flex gap-2 font-sm align-items-center  custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      Disturbed sleep
                    </div>

                    <div className="d-flex gap-2 font-sm align-items-center  custom-ticks">
                      <div className="font-lg fas fa-check "></div>
                      Gallstones and liver problems
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg d-flex justify-content-center">
          <div className="width_80  ">
            <div className="review-title">
              <h1 className="font-lg mb-4 text-center">The <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> Mantra</h1>
            </div>
            <div>
              <div className="delivery-list">
                <div className="d-flex align-items-start gap-4 mb-3">
                  <div>
                    <img
                      src="../assets/images/AbdominalObesity/One.png"
                      className="image-size-number"
                    />
                  </div>

                  <div>
                    <div className="font-sm-mantra fw-semibold mb-1">
                      Does a ‘Reduced Carbohydrate’ approach help in tackling
                      obesity and abdominal obesity?
                    </div>
                    <div className="font-xsm text-muted justify_content">
                      A low-carb diet causes the body to burn stored fat for
                      energy, which leads to weight loss. It normalizes higher
                      insulin levels thus reducing fat accumulation. Hence,
                      carbohydrate restriction is a strategy used for weight
                      loss. It may also have health benefits beyond weight loss,
                      such as lowering abdominal obesity, risk of type 2
                      diabetes and metabolic syndrome.
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-start gap-4 mb-3">
                  <div>
                    <img
                      src="../assets/images/AbdominalObesity/Two.png"
                      className="image-size-number"
                    />
                  </div>
                  <div>
                    <div className="font-sm-mantra fw-semibold mb-1">
                    <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> and dual benefits
                    </div>
                    <div className="font-xsm text-muted justify_content">
                      Reducing daily Carbohydrates not only helps to reduce your
                      weight but also helps in improving insulin sensitivity by
                      controlling  sugar levels. Low-carb diets focus on healthy
                      sources of carbs, fat and protein and may help lower the
                      risk of type 2 diabetes and heart disease.
                    </div>
                    <div className="font-xsm fw-semibold color-blue-abdominal mt-2">
                      Carbohydrate restriction helps in reducing weight as well
                      as blood sugar. One approach, two benefits!!!
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-start gap-4 mb-3">
                  <div>
                    <img
                      src="../assets/images/AbdominalObesity/Three.png"
                      className="image-size-number"
                    />
                  </div>
                  <div>
                    <div className="font-sm-mantra fw-semibold mb-1">
                      Low Carb vs. Low Fat Diets — Best for Weight Loss?
                    </div>
                    <div className="font-xsm text-muted justify_content">
                      Many people look at low fat diet strategy to help them
                      lose weight. Nonetheless, emerging research shows that low
                      carb diets may be more effective. What’s more, low carb
                      diets have been shown to increase fat loss, reduce hunger,
                      improve insulin sensitivity and balance blood sugar
                      levels. Low-carbohydrate approach seems more ideal to
                      induce weight loss in overweight individuals compared with
                      low-fat diet , as it is generally exerting more rapid
                      weight reduction with a greater loss in body fat and
                      maintenance of lean mass.<br></br>
                    </div>
                    <div className="font-xsm fw-semibold  color-blue-abdominal mt-2">
                      Carbohydrate restriction is better than fat restriction.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="background_banner_section_blue py-4">
        <div className="container-fluid-lg">
          <div className="d-flex align-items-center justify-content-center">
            <div className="ms-3 text-white  font-md poppins-text w-75">
              <div>
                <span className="text-center ">
                  In country like India with excess carbohydrate intake,
                  irregular and unhealthy dietary habits, higher stress and
                  sedentary lifestyle, reduction in daily carbohydrate intake
                  would be highly beneficial.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
          <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        Carbohydrate reduction and Clinical Evidence
                      </h1>
                    </div>
                    <div className="">
                      <p className="justify_content">
                        In light of the evidence supporting the benefits of
                        carbohydrate restriction, this eating pattern should be
                        considered as a legitimate option. A low carbohydrate
                        eating pattern based on whole foods can meet nutritional
                        needs, promote satiety, improve insulin sensitivity and
                        provide a varied, highly palatable meal plan that can be
                        followed indefinitely. Moderate carbohydrate restriction
                        has also been shown to be modestly effective for better
                        metabolic profiles (reduction in weight, blood lipids
                        and sugar). It is also important to note the role of
                        physical activity for people who are overweight, have
                        abdominal obesity, and pre-diabetes
                      </p>
                      <div className="mt-1 fw-semibold color-blue-abdominal font-xsm">
                        Now it’s scientifically proven!!!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 mb-3">
              <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/AbdominalObesity/abd-three.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

          
          </div>
        </div>
      </section>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default AbdominalObesity;
